/* 🔧 UTILS */
import { createStep } from "./index";

export const compareSteps = (t) => [
    createStep({
        selector: '#add-equipment-button',
        stepNumber: 1,
        titleKey: t("tour.compare.add-equipment-button.title"),
        textKey: t("tour.compare.add-equipment-button.text"),
    }),
    createStep({
        selector: '#add-variable-button',
        stepNumber: 2,
        titleKey: t("tour.compare.add-variable-button.title"),
        textKey: t("tour.compare.add-variable-button.text"),
    }),
    createStep({
        selector: '#calendar',
        stepNumber: 3,
        titleKey: t("tour.compare.calendar.title"),
        textKey: t("tour.compare.calendar.text"),
    }),
    createStep({
        selector: '#axis-config-button',
        stepNumber: 4,
        titleKey: t("tour.compare.axis-config-button.title"),
        textKey: t("tour.compare.axis-config-button.text"),
    }),
    createStep({
        selector: '#variable-config',
        stepNumber: 5,
        titleKey: t("tour.compare.variable-config.title"),
        textKey: t("tour.compare.variable-config.text"),
    }),
];

export const handleComparePrevStep = (currentStep, setCurrentStep) => {

    const stepActions = {
        4: () => {
            const axisConfigButton = document.querySelector('#axis-config-button');
            if (axisConfigButton) {
                setCurrentStep(3);
            } else { 
                setCurrentStep(2);
            }
        }
      };
    
      if (stepActions[currentStep]) {
          stepActions[currentStep]();
      } else {
          setCurrentStep(currentStep - 1);
      }
};

export const handleCompareNextStep = (currentStep, setCurrentStep, setIsOpen) => {
  
    const stepActions = {
        2: () => {
            const axisConfigButton = document.querySelector('#axis-config-button');
            if (axisConfigButton) {
                setCurrentStep(3);
            } else { 
                setCurrentStep(4);
            }
        },
        4: () => {
            setIsOpen(false);
            setCurrentStep(0);
        }
    };

    if (stepActions[currentStep]) {
      stepActions[currentStep]();
    } else {
      setCurrentStep(currentStep + 1);
    }
};